import { DevTool as HookFormDevTool } from '@hookform/devtools';
import { useFormContext } from 'react-hook-form';

import type { ComponentProps, FC } from 'react';

type DevToolProps = ComponentProps<typeof HookFormDevTool>;

export const DevTool: FC<DevToolProps> = (props) => {
  const { control } = useFormContext();

  return <HookFormDevTool control={control} {...props} />;
};
